export function getCurrentUrl(location) {
  return location.pathname.split(/[?#]/)[0];
}

export function checkIsActive(location, url) {
  // console.log(url);
  const current = getCurrentUrl(location);
  if (!current || !url) {
    return false;
  }

  if (current === url) {
    return true;
  }

  // Check if current path starts with url (for parent routes)
  // But only if url is not just "/" to avoid matching everything
  if (url !== "/" && current.indexOf(url) === 0) {
    // Ensure it's a path boundary match (url should be followed by / or end of string)
    const nextChar = current.charAt(url.length);
    if (!nextChar || nextChar === "/" || nextChar === "?") {
      return true;
    }
  }

  return false;
}
